<style lang="scss" scoped>
.font-weight {
    font-weight: 800;
}
</style>
<template>
    <div>
        <compWrapper
            :title="
                $t('boss.purchase.supplier_information', {
                    defaultValue: '供应商信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getSupplier"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="supplierEditForm"
                :formdata="getSupplier"
                v-model="formData"
                :labelWidth="120"
            />
            <template v-if="type != 'query'" slot="footer">
                <vButton class="margin-right-20" theme="primary" @click="submit"
                    >{{ $t("boss.purchase.save", { defaultValue: "保存" }) }}
                </vButton>
                <vButton class="margin-right-20" @click="cancel">{{
                    $t("boss.purchase.cancel", { defaultValue: "取消" })
                }}</vButton>
            </template>
        </compWrapper>
        <!-- 工商登记信息 -->
        <compWrapper
            :title="
                $t('boss.purchase.business_registration_information', {
                    defaultValue: '工商登记信息',
                })
            "
            theme="info"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getGongshang"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="bussinessEditform"
                :formdata="getGongshang"
                v-model="formData"
                :labelWidth="120"
            />
        </compWrapper>
        <!-- 收款信息 -->
        <compWrapper
            :title="
                $t('boss.purchase.business_registration_information', {
                    defaultValue: '收款信息',
                })
            "
            theme="primary"
        >
            <compFormQuery
                v-if="type == 'query'"
                class="margin-top-15 margin-right-15"
                :formdata="getCollection"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-top-15 margin-right-15"
                ref="receiveEditform"
                :formdata="getCollection"
                v-model="formData"
                :labelWidth="120"
            />
            <!-- <vForm class="margin-15 margin-right-15 other-form clearfix" style="margin-top: -5px;" labelWidth="105">
                <vCol span="12">
                    <vFormItem class="form-item" label='预付款比例'>
                    <div v-if="type !== 'query'">
                        <vCol span="22">
                            <InputNumber style="width: 100%;" v-model="formData.paymentRate" min="0" ></InputNumber>
                        </vCol>
                        <vCol span="2" style="text-align: right;">%</vCol>
                    </div>
                    <div v-else class="font-weight">{{formData.paymentRate ? formData.paymentRate + '%' : ''}}</div>
                    </vFormItem>
                </vCol>
            </vForm> -->
        </compWrapper>
        <!-- 联系人信息 -->
        <compWrapper
            :title="
                $t('boss.purchase.contacts', {
                    defaultValue: '联系人信息',
                })
            "
            theme="primary"
        >
            <compConnect
                :connectdata="formData.supplierContactList"
                ref="refconnect"
                :type="type"
            ></compConnect>
        </compWrapper>
        <!-- 其他信息 -->
        <compWrapper
            :title="
                $t('boss.purchase.other_information', {
                    defaultValue: '其他信息',
                })
            "
            theme="primary"
        >
            <vForm class="margin-15 other-form clearfix" labelWidth="140">
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.assurance_period_days', {
                                defaultValue: '产品质量保证期（天）',
                            })
                        "
                    >
                        <InputNumber
                            style="width: 100%"
                            v-if="type !== 'query'"
                            v-model="formData.productGuaranteePeriod"
                            min="0"
                        ></InputNumber>
                        <div v-else class="font-weight">
                            {{ formData.productGuaranteePeriod }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.refund_a', {
                                defaultValue: '退款/退货率',
                            })
                        "
                    >
                        <div v-if="type !== 'query'">
                            <vCol span="22">
                                <InputNumber
                                    style="width: 100%"
                                    v-model="formData.refundReturnRate"
                                    min="0"
                                ></InputNumber>
                            </vCol>
                            <vCol span="2" style="text-align: right">%</vCol>
                        </div>
                        <div v-else class="font-weight">
                            {{
                                formData.refundReturnRate
                                    ? formData.refundReturnRate + "%"
                                    : ""
                            }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.delay_delivery', {
                                defaultValue: '延迟交货违约条款',
                            })
                        "
                    >
                        <vInput
                            style="width: 100%"
                            v-if="type !== 'query'"
                            v-model="formData.deliveryBreachClause"
                        ></vInput>
                        <div
                            v-else
                            class="font-weight"
                            style="width: 100%; height: 40px; overflow: auto"
                        >
                            {{ formData.deliveryBreachClause }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.short_overflow_ratio', {
                                defaultValue: '短溢装比例',
                            })
                        "
                        style="margin-bottom: 5px"
                    >
                        <div v-if="type !== 'query'">
                            <vCol span="22">
                                <InputNumber
                                    style="width: 100%"
                                    v-model="formData.overRate"
                                    min="0"
                                ></InputNumber>
                            </vCol>
                            <vCol span="2" style="text-align: right">%</vCol>
                        </div>
                        <div v-else class="font-weight">
                            {{
                                formData.overRate ? formData.overRate + "%" : ""
                            }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.inspection_fee_standard', {
                                defaultValue: '重验费标准',
                            })
                        "
                        style="margin-bottom: 5px"
                    >
                        <vInput
                            style="width: 100%"
                            v-if="type !== 'query'"
                            v-model="formData.reinspectionFeeStandard"
                        ></vInput>
                        <div
                            v-else
                            class="font-weight"
                            style="
                                max-height: 100px;
                                overflow: auto;
                                word-break: break-all;
                            "
                        >
                            {{ formData.reinspectionFeeStandard }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.bind_customer', {
                                defaultValue: '绑定客户',
                            })
                        "
                        style="min-height: 25px"
                    >
                        <div v-if="type != 'query'">
                            <vSelect v-model="formData.customerId">
                                <vOption
                                    v-for="(item, index) in getAllCustomerList"
                                    :key="index"
                                    :value="item.value"
                                    >{{ item.label }}</vOption
                                >
                            </vSelect>
                            <div style="position: absolute" class="color-error">
                                {{
                                    $t("boss.purchase.automatic_offsetting", {
                                        defaultValue:
                                            "说明该供应商也是客户，可用于系统内应收应付账款的自动冲抵。",
                                    })
                                }}
                            </div>
                        </div>
                        <div v-else class="font-weight">
                            {{ getCustomer(formData.customerId) }}
                        </div>
                    </vFormItem>
                </vCol>

                <vCol span="12">
                    <vFormItem
                        :label="
                            $t('boss.purchase.select_data', {
                                defaultValue: '关联供应商',
                            })
                        "
                    >
                        <vSelect
                            v-if="type != 'query'"
                            v-model="formData.relateSupplier"
                            multiple
                            filterable
                        >
                            <vOption
                                v-for="(item, index) in getAllSupplier"
                                :key="index"
                                :value="item.value"
                                >{{ item.label }}</vOption
                            >
                        </vSelect>
                        <div v-else class="font-weight">
                            {{ getSupperList(formData.relateSupplier) }}
                        </div>
                    </vFormItem>
                </vCol>
                <vCol span="12">
                    <vFormItem
                        class="form-item"
                        :label="
                            $t('boss.purchase.notes', {
                                defaultValue: '备注',
                            })
                        "
                    >
                        <vTextarea
                            v-if="type != 'query'"
                            v-model="formData.remark"
                        ></vTextarea>
                        <div v-else class="font-weight">
                            {{ formData.remark }}
                        </div>
                    </vFormItem>
                </vCol>
            </vForm>
            <div v-if="type != 'query'" style="margin-top: 30px">
                <vButton
                    class="margin-left-20 margin-top-15 margin-bottom-15"
                    theme="primary"
                    @click="adddocument"
                    >{{
                        $t("boss.purchase.attachment_upload", {
                            defaultValue: "附件上传",
                        })
                    }}</vButton
                >
                <span class="margin-left-10 color-error">{{
                    $t("boss.purchase.attachments_uploaded", {
                        defaultValue: "最多传5个附件，超过请压缩后再上传",
                    })
                }}</span>
            </div>
            <vTable
                class="margin-20"
                :columns="doccolumns"
                :data="datalist"
                size="small"
                ref="tablequery"
                border
            ></vTable>
        </compWrapper>
        <!-- 操作历史 -->
        <compWrapper
            :title="
                $t('boss.purchase.operations_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
            v-if="type == 'query'"
        >
            <compLog :data="logList"></compLog>
        </compWrapper>

        <vLoading size="large" transfer :loading="loading"></vLoading>

        <compModal v-model="modalProps.show" v-bind="modalProps">
            <component
                :is="modalProps.component"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>

        <vModal
            class="hidefooter customerupload"
            v-model="operate.show"
            :title="operate.title"
            v-bind="operate"
        >
            <compMutiUpload
                v-bind="getFileProps"
                @on-success="aaasuccess"
                @on-cancel="cancelUpload"
            />
            <footer slot="footer" v-show="false"></footer>
        </vModal>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
    HttpGetSupplierOne,
    HttpSaveSupplierOne,
    HttpDelAttach,
    HttpDelAttachNew,
    HttpGetPaymentByOrgId,
} from "@/service/purchase/purchase";
import { HttpSysOpLog } from "@/service/boss/allot";
import compConnect from "./connect";
import compPaymentTermList from "../../paymenttermlist.vue";
import compPaymentTermDetail from "../../paymenttermdetail.vue";
export default {
    props: ["activeid", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
        compLog: () => import("@components/templates/log"),
        compModal: () => import("@components/templates/modal"),
        compConnect,
        compPaymentTermList,
        compPaymentTermDetail,
    },
    data() {
        return {
            type: this.$route.params.type,
            id: this.$route.query.id,
            formData: {
                // paymentDay: null,
                // paymentRate: null,
                productGuaranteePeriod: null,
                refundReturnRate: null,
                overRate: null,
                relateSupplier: null,
                supplierType: 0,
            },
            logList: [],
            datalist: [],
            operate: {
                id: null,
                title: "",
                show: false,
                actionurl: "",
                boxtype: "",
                downexcel: "",
                component: null,
            },
            modalProps: {
                show: false,
            },
            paymentItem: {
                paymentName: null,
            },
            paymentList: [],
            loading: false,
        };
    },
    async created() {
        if (this.type !== "add") {
            this.loading = true;
            await this.getPaymentTerm();
            await this.update();
            this.loading = false;
        }
    },
    computed: {
        ...mapGetters("diction", [
            "getAllCurrency",
            "getNewWarehouseCodeList",
            "getNewWarehouseIdList",
            "getAllCustomerList",
            "getAllSupplier",
        ]),
        getFileProps() {
            return {
                data: {
                    // sourceId:this.id || 0,
                    srcLabel: this.id || 0,
                    model: "supplier",
                    type: "other",
                },
                action: process.env.VUE_APP_APIURL_UC + this.operate.actionurl,
                name: "multipartFile",
                multiple: true,
                beforeUpload: (fileList) => {
                    if (fileList.length > 5) {
                        this.$VMessage.error(
                            this.$t("boss.purchase.package_and_upload", {
                                defaultValue: "附件数量过多，请打包后上传",
                            })
                        );
                        return false;
                    } else {
                        return true;
                    }
                },
            };
        },
        getSupplier() {
            return [
                {
                    label: this.$t("boss.purchase.supplier_code", {
                        defaultValue: "供应商编码",
                    }),
                    key: "code",
                    tag: "vInput",
                    show: this.type != "add",
                    query: true,
                },
                {
                    label: this.$t("boss.purchase.supplier_name_chinese", {
                        defaultValue: "供应商名称(中文)",
                    }),
                    key: "name",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.supplier_name_english", {
                        defaultValue: "供应商名称(中文)",
                    }),
                    key: "nameEn",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.supplier_address_chinese", {
                        defaultValue: "供应商地址(中文)",
                    }),
                    key: "address",
                    tag: "vInput",
                },
                {
                    label: this.$t("boss.purchase.supplier_address_english", {
                        defaultValue: "供应商地址(英文)",
                    }),
                    key: "addressEn",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.supplier_classification", {
                        defaultValue: "供供应商分类",
                    }),
                    key: "bizCategory",
                    tag: "vSelect",
                    options: [
                        {
                            value: "STATUS_JOINT_OPERATION",
                            label: this.$t("boss.purchase.joint_operation", {
                                defaultValue: "联合运营",
                            }),
                        },
                        {
                            value: "STATUS_SELF_OPERATION",
                            label: this.$t(
                                "boss.purchase.autonomous_operation",
                                {
                                    defaultValue: "自主运营",
                                }
                            ),
                        },
                        {
                            value: "STATUS_PLATFORM",
                            label: this.$t("boss.purchase.platform", {
                                defaultValue: "平台",
                            }),
                        },
                        {
                            value: "STATUS_OTEHR",
                            label: this.$t("boss.purchase.other", {
                                defaultValue: "其他",
                            }),
                        },
                    ],
                    props: {
                        filterable: true,
                    },
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.collaboration_mode", {
                        defaultValue: "合作方式",
                    }),
                    key: "coMode",
                    tag: "vSelect",
                    options: [
                        // {value:"UNDEFINE",label:"无合作方式"},
                        {
                            value: "FACTORY",
                            label: this.$t("boss.purchase.factory", {
                                defaultValue: "工厂",
                            }),
                        },
                        {
                            value: "TRADE",
                            label: this.$t("boss.purchase.foreign_trade", {
                                defaultValue: "外贸",
                            }),
                        },
                        {
                            value: "OTHER",
                            label: this.$t("boss.purchase.other", {
                                defaultValue: "其他",
                            }),
                        },
                    ],
                    props: {
                        filterable: true,
                    },
                    required: false,
                    render: (h) => {
                        if (this.type === "query") {
                            switch (this.formData.coMode) {
                                // case 'UNDEFINE': return '无合作方式';
                                case "FACTORY":
                                    return this.$t("boss.purchase.factory", {
                                        defaultValue: "工厂",
                                    });
                                case "TRADE":
                                    return this.$t(
                                        "boss.purchase.foreign_trade",
                                        {
                                            defaultValue: "外贸",
                                        }
                                    );
                                case "OTHER":
                                    return this.$t("boss.purchase.other", {
                                        defaultValue: "其他",
                                    });
                            }
                        }
                    },
                },
                {
                    label: this.$t("boss.purchase.contact_person", {
                        defaultValue: "对接人",
                    }),
                    key: "broker",
                    tag: "vInput",
                    props: {
                        placeholder: this.$t(
                            "boss.purchase.employee_communicating",
                            {
                                defaultValue: "与供应商沟通对接的员工姓名",
                            }
                        ),
                    },
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.supplier_type", {
                        defaultValue: "供应商类型",
                    }),
                    key: "supplierType",
                    tag: "vSelect",
                    required: false,
                    props: {
                        clearable: true,
                    },
                    options: [
                        {
                            value: 0,
                            label: this.$t(
                                "boss.purchase.purchasing_suppliers",
                                {
                                    defaultValue: "采购供应商",
                                }
                            ),
                        },
                        {
                            value: 1,
                            label: this.$t("boss.purchase.service_provider", {
                                defaultValue: "服务供应商",
                            }),
                        },
                    ],
                },
            ];
        },
        getGongshang() {
            return [
                {
                    label: this.$t("boss.purchase.legal_representative", {
                        defaultValue: "法人代表",
                    }),
                    key: "contact",
                    tag: "vInput",
                    required: false,
                },
                // {
                // 	label: "供应商资质",
                //     key:"endowment",
                // 	tag: "vInput",
                //     required: false,
                // },
                {
                    label: this.$t("boss.purchase.social_credit_code", {
                        defaultValue: "统一社会信用代码",
                    }),
                    key: "licenseNo",
                    tag: "vInput",
                    required: false,
                },
                // {
                // 	label: "税务登记证",
                // 	key: "taxNo",
                // 	tag: "vInput",
                // 	required: false,
                // },
                // {
                // 	label: "工商登记证",
                // 	key: "commercialNo",
                // 	tag: "vInput",
                // 	required: false,
                // },
                {
                    label: this.$t("boss.purchase.business_scope", {
                        defaultValue: "工商经营范围",
                    }),
                    key: "bizRange",
                    tag: "vInput",
                    required: false,
                },
            ];
        },
        getCollection() {
            return [
                {
                    label: this.$t("boss.purchase.opening_bank", {
                        defaultValue: "开户行",
                    }),
                    key: "bank",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.account_number", {
                        defaultValue: "账号",
                    }),
                    key: "accountNo",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.bank_address_branch_name", {
                        defaultValue: "银行地址或支行名称",
                    }),
                    key: "bankAddress",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.name_of_payee", {
                        defaultValue: "收款人名称",
                    }),
                    key: "receiver",
                    tag: "vInput",
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.payment_remarks", {
                        defaultValue: "收款备注",
                    }),
                    key: "receiverRemark",
                    tag: "vInput",
                    required: false,
                },
                // {
                // 	label: "传真",
                // 	key: "fax",
                // 	tag: "vInput",
                // 	required: false,
                // },
                {
                    label: this.$t("boss.purchase.settlement_type", {
                        defaultValue: "成本结算类型",
                    }),
                    key: "costType",
                    tag: "vSelect",
                    options: [
                        { value: "FOB", label: "FOB" },
                        { value: "DDP", label: "DDP" },
                        { value: "DDU", label: "DDU" },
                        { value: "CIF", label: "CIF" },
                        { value: "EXW", label: "EXW" },
                        { value: "FCA", label: "FCA" },
                    ],
                    props: {
                        filterable: true,
                    },
                    required: false,
                },
                {
                    label: this.$t("boss.purchase.settlement_remarks", {
                        defaultValue: "结算备注",
                    }),
                    key: "paymentExplain",
                    tag: "vInput",
                    required: false,
                },
                // {
                //     label: '账期（天）',
                //     key: 'paymentDay',
                //     tag: 'InputNumber',
                //     props: {
                //         min: 0
                //     },
                //     required: false,
                //     style: 'width: 100%'
                // },
                // {
                //     label: '预付款比例（%）',
                //     key: 'paymentRate',
                //     tag: 'InputNumber',
                //     props: {
                //         min: 0
                //     },
                //     required: false,
                //     render: (h) => {
                //       return <div>123456</div>
                //     },
                //     chilld: (h) => {
                //         return <div>12456</div>
                //     }
                // }
                {
                    label: "Payment Term",
                    key: "paymentTerm",
                    tag: "div",
                    required: false,
                    children: (h) => {
                        console.log("paymentName", this.paymentItem);
                        return (
                            <Input
                                value={this.paymentItem.paymentName}
                                readonly
                            >
                                <Icon
                                    style="cursor: pointer;"
                                    slot="suffix"
                                    type="md-search"
                                    nativeOnClick={this.handleChoosePayment.bind(
                                        this
                                    )}
                                ></Icon>
                            </Input>
                        );
                    },
                    render: (h) => {
                        let paymentItem = this.paymentList.filter((item) => {
                            return item.id == this.formData.paymentTermId;
                        })[0];
                        if (paymentItem) {
                            return (
                                <div>
                                    <a
                                        class="font-bold"
                                        onClick={this.handlePaymentDetail.bind(
                                            this,
                                            this.formData.paymentTermId
                                        )}
                                    >
                                        {paymentItem.paymentName}
                                    </a>
                                </div>
                            );
                        } else {
                            return <div class="font-bold">--</div>;
                        }
                    },
                },
            ];
        },
        doccolumns() {
            let _this = this;
            return [
                {
                    title: this.$t("boss.purchase.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    key: "attachTitle",
                },
                {
                    title: this.$t("boss.purchase.attachment_link", {
                        defaultValue: "附件链接",
                    }),
                    key: "attachUrl",
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    width: 120,
                    render(h, { row, index }) {
                        let delButton = "";
                        if (_this.type !== "query") {
                            delButton = h(
                                "vButton",
                                {
                                    props: {
                                        theme: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                    style: {
                                        "margin-right": "15px",
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            );
                        }
                        return h("div", [
                            delButton,
                            h(
                                "vButton",
                                {
                                    props: {
                                        theme: "primary",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.downfile(row.attachUrl);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.download", {
                                    defaultValue: "下载",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        handlePaymentDetail() {
            this.modalProps = {
                show: true,
                width: 1200,
                title: "Payment Term",
                component: "compPaymentTermDetail",
                params: this.formData.paymentTermId,
                querytype: "query",
                showFooter: false,
            };
        },
        async getPaymentTerm() {
            await HttpGetPaymentByOrgId().then(
                (res) => {
                    this.paymentList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleChoosePayment() {
            this.modalProps = {
                show: true,
                width: 900,
                title: this.$t("boss.purchase.select_Payment_Term", {
                    defaultValue: "选择Payment Term",
                }),
                component: "compPaymentTermList",
                showFooter: false,
                on: {
                    "on-close": () => {
                        console.log("on-close");
                        this.modalProps.show = false;
                    },
                    "on-confirm": (data) => {
                        this.paymentItem = data;
                        this.modalProps.show = false;
                    },
                },
            };
        },
        handleSelect(item) {
            this.$set(this, "paymentItem", val);
        },
        downfile(url) {
            this.handleWebfs(url, {}, "download");
        },
        adddocument() {
            this.operate = {
                show: true,
                title: this.$t("boss.purchase.add_attachment", {
                    defaultValue: "添加附件",
                }),
                actionurl: "/api/v1/BizAttach/uploadFile",
                boxtype: "document",
                downexcel: "",
            };
        },
        aaasuccess(res) {
            res.items.map((item) => {
                this.datalist.push(item);
            });
            this.cancelUpload();
        },
        remove(index, useId) {
            // 新增时删除附件用另外的接口
            if (this.type === "add") {
                HttpDelAttachNew({
                    id: useId ? index : this.datalist[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.datalist.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
            // 编辑
            else {
                HttpDelAttach({
                    id: this.id || 0,
                    attachId: useId ? index : this.datalist[index].attachId,
                }).then(
                    (res) => {
                        if (!useId) {
                            this.datalist.splice(index, 1);
                            this.$VMessage.success(res.message);
                        }
                    },
                    (err) => {
                        if (!useId) {
                            this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true,
                            });
                        }
                    }
                );
            }
        },
        cancelUpload() {
            this.operate.show = false;
        },
        getCustomer(id) {
            let json =
                this.getAllCustomerList.filter((item) => {
                    return item.value == id;
                })[0] || {};
            return json.label || "";
        },
        getSupperList(ids) {
            console.log("getAllSupplier", this.getAllSupplier, ids);
            let array = ids || [];
            let listdata = [],
                namelist = [];
            this.getAllSupplier.map((item) => {
                array.map((jsonid) => {
                    if (jsonid == item.value) {
                        listdata.push(item);
                    }
                });
            });
            listdata.map((json) => {
                namelist.push(json.label);
            });
            return namelist.join(",");
        },
        async update() {
            if (this.querytype) {
                this.id = this.activeid;
                this.type = this.querytype;
            } else {
                this.id = this.$route.query.id;
                this.type = this.type;
            }
            if (this.type == "add") return;
            // 日志
            if (this.type == "query") {
                await HttpSysOpLog({
                    "search[EQ_opDataId]": this.id,
                    "search[EQ_opModel]": "supplier",
                }).then(
                    (res) => {
                        this.logList = res.data.content;
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                );
            }
            await HttpGetSupplierOne({
                id: this.id,
            }).then(
                (res) => {
                    this.formData = res.data;
                    if (this.formData.paymentTermId) {
                        console.log(this.paymentList);
                        this.paymentItem = this.paymentList.filter((item) => {
                            return item.id == this.formData.paymentTermId;
                        })[0];
                    }
                    console.log(this.formData.paymentTermId, this.paymentItem);
                    // this.formData.paymentDay = res.data.paymentDay === null || this.formData.paymentDay === '' ? undefined : res.data.paymentDay
                    this.datalist = res.data.meta
                        ? JSON.parse(res.data.meta).items
                        : [];
                    if (!this.formData.relateSupplier) {
                        this.formData.relateSupplier = [];
                    } else {
                        this.formData.relateSupplier =
                            this.formData.relateSupplier.split(",");
                    }
                },
                (err) => {
                    this.errorMessage(err.message);
                }
            );
        },
        async submit() {
            let flag = false;
            await this.$refs.supplierEditForm.validate((valid) => {
                if (!valid) return (flag = true);
            });
            if (flag)
                return this.$VMessage.error(
                    this.$t("boss.purchase.required_fields", {
                        defaultValue: "请填写必填项",
                    })
                );
            // :connectdata="formData.supplierContactList" ref="refconnect"
            this.formData.supplierContactList = this.$refs.refconnect.formList;
            if (this.formData.supplierContactList.length > 0) {
                let flagSet = new Set();
                this.formData.supplierContactList.map((item) => {
                    if (item.isDefault === 0) {
                        flagSet.add(false);
                    } else {
                        flagSet.add(true);
                    }
                });
                if (flagSet.size === 1 && flagSet.has(false)) {
                    return this.$VMessage.error(
                        this.$t("boss.purchase.default_contact_person", {
                            defaultValue: "至少选择一个默认联系人",
                        })
                    );
                }
            }
            this.loading = true;
            // console.log(this.formData)
            this.formData.bizCategory = this.formData.bizCategory
                ? this.formData.bizCategory
                : null;
            this.formData.coMode = this.formData.coMode
                ? this.formData.coMode
                : null;
            this.formData.relateSupplier = this.formData.relateSupplier
                ? this.formData.relateSupplier.join(",")
                : "";
            this.formData.paymentTermId = this.paymentItem.id;
            HttpSaveSupplierOne({
                orgId: global.SYSID,
                ...this.formData,
                // paymentDay: this.formData.paymentDay === null || this.formData.paymentDay === undefined ? null : this.formData.paymentDay,
                meta: JSON.stringify({
                    items: this.datalist,
                    opAt: this.datalist[0] ? this.datalist[0].attachOpAt : "",
                    organizationId: global.SYSID,
                }),
            }).then(
                (res) => {
                    this.$Message.success(res.message);
                    this.cancel();
                    this.loading = false;
                },
                (err) => {
                    this.errorMessage(err.message);
                    this.loading = false;
                }
            );
        },

        cancel() {
            this.$router.push({
                name: "supplierList",
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.other-form {
    .form-item {
        height: 42px;
        margin-bottom: 5px;
        clear: both;
    }
}
</style>
